import { IQuote, ISitecoreItem } from '@/interfaces';

export const executeDisplayRules = (
  executeRules: { [K: string]: (quote: IQuote, param?: any) => boolean },
  rules: ISitecoreItem[],
  quote: IQuote,
  param?: any
): boolean => {
  if (rules && rules.length > 0) {
    return rules.some((rule) => {
      const ruleFn = executeRules[rule.name];
      return ruleFn ? ruleFn(quote, param) : true;
    });
  }

  return true;
};

export const executeDisplayRulesNoPolicy = (
  executeRules: { [K: string]: (param?: any) => boolean },
  rules: ISitecoreItem[],
  param?: any
): boolean => {
  if (rules && rules.length > 0) {
    return rules.some((rule) => {
      const ruleFn = executeRules[rule.name];
      return ruleFn ? ruleFn(param) : true;
    });
  }

  return true;
};

export const executeDisplayRulesNoPolicyWithParams = (
  executeRules: { [K: string]: (...params: any[]) => boolean },
  rules: ISitecoreItem[],
  ...params: any[]
): boolean => {
  if (rules && rules.length > 0) {
    return rules.some((rule) => {
      const ruleFn = executeRules[rule.name];
      return ruleFn ? ruleFn(...params) : true;
    });
  }

  return true;
};
